import { PlayerTraining } from './player-training';
import { PlayerRound } from './round-history';

export enum Sport {
  FOOTBALL = 'football',
  HANDBALL = 'handball',
}

export enum NotificationType {
  VIDEO_RATED = 'video_rated',
  REVIEW_ASSIGNED = 'review_assigned',
  CUSTOM = 'custom',
}

export type UserRole = 'player' | 'scout' | 'trainer';

export class Notification {
  id: number;
  heading: string;
  heading_de: string;
  text: string;
  text_de: string;
  is_read: false;
  player_training: PlayerTraining;
  notification_type: NotificationType;
  is_new: false;
  custom_url?: string;
}

export interface Language {
  id: number;
  skill_level: string;
  language: string;
}

export interface CompressedImage {
  SD: string;
  MD: string;
  HD: string;
  FHD: string;
  SQUARE: string;
}

export class Parent {
  first_name: string;
  last_name: string;
  email: string;
  general_consent_accepted?: boolean;
  werder_bremen_consent_accepted?: boolean;
}

export class User {
  id: number;
  identifier: string;
  role: string;
  sport: string;
  email: string;
  phone_number?: any;
  image: CompressedImage;
  first_name: string;
  last_name: string;
  city: string;
  state: string;
  country: string;
  school: string;
  birth_date: string;
  postal_code?: any;
  height: number;
  weight: number;
  languages: Language[];
  gender: string;
  age: number;
  birth_year: number;
  profile: any;
  parent: Parent | null;
  email_verified: boolean;
  active_league: string;
  active_round?: PlayerRound;
  general_parental_consent_required: boolean;
  allowed_in_werder_bremen_tests: boolean;
  zip: number;
}
